import { Component, OnInit, Input, EventEmitter, Output, Inject, DestroyRef } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { AssemblyOrder } from 'app/model';
import { UntypedFormBuilder, UntypedFormGroup, Validators, ReactiveFormsModule } from '@angular/forms';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ToastService } from 'app/core/services/toast/toast.service';
import { WorkplanService } from 'app/workplan/services/workplan.service';
import { ActivatedRoute } from '@angular/router';
import { NgSelectModule } from '@ng-select/ng-select';

@Component({
    selector: 'app-swap-modal',
    templateUrl: './swap-modal.component.html',
    styleUrls: ['./swap-modal.component.scss'],
    imports: [ReactiveFormsModule, NgSelectModule]
})
export class SwapModalComponent implements OnInit {
  @Output() cancelAction = new EventEmitter();

  swapForm: UntypedFormGroup;
  selectableAssemblyOrders = [];

  constructor(
    private fb: UntypedFormBuilder,
    private workplanService: WorkplanService,
    private toastService: ToastService,
    private route: ActivatedRoute,
    private destroyRef: DestroyRef,
    @Inject(MAT_DIALOG_DATA) public data: { assemblyOrders: [], idWorkplan: any, workplanName: string }
  ) { }

  ngOnInit() {
    this.selectableAssemblyOrders = this.data.assemblyOrders.map(assemblyOrder => {
      return {
        id: assemblyOrder['id'],
        name: `${assemblyOrder['machine']['name']}- ${assemblyOrder['client']['fullname']}`,
        machineName: assemblyOrder['machine']['name']
      };
    });
    this.setForm();
  }

  setForm() {
    this.swapForm = this.fb.group({
      idOrigin: [, Validators.required],
      idDestination: [, Validators.required]
    });
  }

  onCancel() {
    this.cancelAction.emit();
  }

  onValueChanges() {
    const formValue = this.swapForm.value;
    if (formValue.idOrigin === formValue.idDestination) {
      this.toastService.danger('', 'Origen y destino no pueden ser iguales');
      this.swapForm.get('idDestination').reset();
    }
  }

  onSwapComplete() {
    const formValue = this.swapForm.value;
    const idWorkplan = this.data.idWorkplan;

    this.workplanService.swapAssemblyOrders(idWorkplan, formValue.idOrigin, formValue.idDestination)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(
        () => {
          this.toastService.success('Desplazamiento guardado!');
          this.cancelAction.emit();
        }
      );
  }

}
